module.exports = __webpack_public_path__ + "img/Ventla-Logo-Grey.e9a660af.svg";